module.exports = __webpack_public_path__ + "static/uthgardt_elk_tribe-b32f29ff6cc7f87fa069497755d27ba3.png";